/**
 * Grammarly Extension Handling
 *
 * This module creates a patch to help handle Grammarly browser extension attributes
 * that cause React hydration warnings.
 */

if (typeof window !== 'undefined') {
  // Add global handler for Grammarly attributes on document load
  document.addEventListener('DOMContentLoaded', () => {
    // Add special attribute to mark Grammarly as handled
    document.documentElement.setAttribute('data-grammarly-handled', 'true')

    // If Grammarly is installed, we can observe for its attributes and handle them
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          (mutation.attributeName?.startsWith('data-gr-') ||
            mutation.attributeName?.startsWith('data-new-gr-'))
        ) {
          // Grammarly has added an attribute, mark it as expected
          const target = mutation.target as HTMLElement
          target.setAttribute('data-grammarly-handled', 'true')
        }
      })
    })

    // Start observing the entire document for Grammarly attribute changes
    observer.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['data-gr-ext-installed', 'data-new-gr-c-s-check-loaded']
    })
  })
}
